import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  href = '#pricing',
  variant = 'primary',
  className = '',
  onClick
}: ButtonProps) {
  const baseStyle = 'inline-flex items-center justify-center font-bold rounded-xl px-8 py-4 text-lg transition-all shadow-lg w-full sm:w-auto text-center';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-400 text-slate-900 shadow-amber-500/20',
    secondary: 'bg-slate-800 hover:bg-slate-700 text-white border border-slate-700',
    danger: 'bg-red-600 hover:bg-red-500 text-white shadow-red-600/20'
  };
  const Component = href ? motion.a : motion.button;
  const props = href ? {
    href
  } : {
    onClick
  };
  return <Component {...props} className={`${baseStyle} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-44">
      {children}
    </Component>;
}